import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'key' })
export class KeyPipe implements PipeTransform {

    public constructor() { }

    transform(value: any, key: string): any {
        let seprator = '';
        for (let i = 0; i < key.length; i++) {
            if (key[i] == '.' || key[i] == '/') {
                seprator = key[i];
                break;
            }
        }

        if (seprator) {
            const segments = key.split(seprator);
            let result = value;
            while (segments.length) {
                const k = segments.shift();
                result = result[k];
                if (result == null) break;
            }
            return result;
        }
        else return value[key];
    }
}